import { Box, Typography } from '@mui/material';
import { useState } from 'react';

import PageTabMenu from 'src/components/page-tab-menu/page-tab-menu';
import PageTabPanel from 'src/components/page-tab-panel/page-tab-panel';
import Page from 'src/components/page/page';

import Benefits from '../benefits/benefits/components/benefits/benefits';
import Categories from './components/categories/categories';

export default function BenefitsConfig() {
  const [tabValue, setTabValue] = useState(0);
  const changeTab = (value: number) => {
    setTabValue(value);
  };

  return (
    <Page title="Configuração Benefícios">
      <Typography typography="bold-hd-lg">Configuração Benefícios</Typography>
      <Box height={32} />
      <PageTabMenu
        options={[
          { title: 'Benefícios', value: 0 },
          { title: 'Categorias', value: 1 },
        ]}
        onChangeTab={changeTab}
        tabValue={tabValue}
      />
      <Box height={32} />
      <PageTabPanel panels={[<Benefits />, <Categories />]} tabValue={tabValue} />
    </Page>
  );
}
